export default __webpack_public_path__ + "static/media/download.9eb5ac03.svg";